<div class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">
        {{ measureTaskTitle }}
      </h2>
    </div>
    <div fxLayout="column">
      <div fxLayout="row">
        <div fxLayout="column" fxLayoutGap="5px" class="add-button-style">
          <span #myMeasuresButton fxLayoutAlign="end" class="buttons-container" (click)="loadMyMeasureTasks()">
            {{ tasksTitle }}
          </span>
        </div>
        <div fxLayout="column" fxLayoutGap="5px" class="add-button-style">
          <span #myMeasuresButton fxLayoutAlign="end" class="buttons-container" (click)="loadMyMeasureMilestones()">
            {{ milestonesTitle }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <div class="content-block">
    <div class="dx-card responsive-paddings card-radius">
      <abc-grid
        #measureGrid
        class="grid-group-by-Style chech-box-Column custome-export-style"
        [height]="'100%'"
        [rowAlternationEnabled]="false"
        (onCellPrepared)="onCellPrepared($event)"
        [noDataText]="noDataText"
        [setupDefaultLayoutOnInitialization]="true"
        [columnChooser]="{ search: { enabled: true }, enabled: true }"
        [hoverStateEnabled]="false"
        [showRowLines]="false"
        [columns]="columnsHeader"
        [dataSource]="measureTasks"
        (onCellClick)="onCellClick($event)"
      >
        <dxo-group-panel [visible]="true"></dxo-group-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-scrolling mode="virtual"></dxo-scrolling>
        <dxo-selection mode="single"></dxo-selection>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-paging [enabled]="false"></dxo-paging>
        <dxo-search-panel [visible]="true" [highlightCaseSensitive]="true"> </dxo-search-panel>
        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-summary>
          <dxi-total-item
            column="TotalTimeRequired"
            summaryType="sum"
            valueFormat="#,##0 h"
            displayFormat="{{ dataService.res('Ubt-Report-Total') }}: {0}"
          >
          </dxi-total-item>
        </dxo-summary>
        <dxo-paging [enabled]="false"></dxo-paging>
      </abc-grid>
    </div>
  </div>
</div>

<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
